<template>
  <div class="app-wrapper">
    <!-- 页面顶部 -->
    <!-- <div class="h-topbar-wrapper">
      <topbar></topbar>
    </div>-->
    <div style="height: 60px" v-show="!fullScreen">
      <topbar class="h-topbar-wrapper"></topbar>
    </div>
    <div class="main-wrapper" :class="{ hideSidebar: !sidebar.opened, fullScreen: fullScreen }">
      <!-- 侧边栏 -->
      <sidebar class="h-sidebar-wrapper" v-show="!fullScreen"></sidebar>
      <!-- 中间区域 -->
      <div class="main-container clearfix">
        <!-- 顶部 -->
        <!-- <div class="h-topbar-wrapper" v-show="!fullScreen">
          <topbar></topbar>
        </div>-->
        <!-- 面包屑导航栏 -->
        <!-- <navbar v-show="!fullScreen"></navbar> -->
        <!-- 内容 -->
        <ConstHome v-if="consoleShow"></ConstHome>
        <BackTop ></BackTop>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
  import { Navbar, Sidebar, AppMain, Topbar, ConstHome } from './index'
  import { mapGetters } from 'vuex'
  import BackTop from '@/components/backToTop'
  export default {
    name: 'layout',
    data () {
      return {
        consoleShow: this.$route.name == '控台首页' ? true : false,
      }
    },
    watch: {
      $route (to, from) {
        // 
        this.consoleShow = this.$route.name == '控台首页' ? true : false
        console.log(this.$route.name)
      },
    },
    components: {
      Navbar,
      Sidebar,
      AppMain,
      Topbar,
      ConstHome,
      BackTop
    },
    computed: {
      sidebar () {
        return this.$store.state.app.sidebar
      },
      ...mapGetters(['activeIndex', 'fullScreen']),
    },
  }
</script>
<style lang="scss" scoped>
  .app-wrapper {
    background: url(https://img.alicdn.com/tfs/TB1C0s8aDtYBeNjy1XdXXXXyVXa-3304-740.jpg)
    no-repeat;
    background-size: cover;
  }
  .main-wrapper {
    margin: 0;
    margin-top: 10px;
  }
  .h-topbar-wrapper {
    position: fixed;
    top: 0;
    background-color: #051337;
    height: 60px;
    width: 100%;
  }
  .h-sidebar-wrapper {
    top: 60px;
    width: 154px;
  }

  .clearfix:after {
    display: block;
    content: '';
    clear: both;
    visibility: hidden;
    height: 0;
  }
  .clearfix {
    zoom: 1;
  }
  .main-container {
    margin-left: 172px;
    min-height: calc(100vh - 60px);
    width: calc(100% - 188px);
  }
</style>



// WEBPACK FOOTER //
// src/gtn/views/consoleViews/consoleMain.vue